import * as React from 'react';
import { renderComponent } from './RenderComponent';
import ErrorPage from './components/clearstep/ErrorPage/ErrorPage';
renderComponent(function () {
    return React.createElement(ErrorPage, {
        statusCode: window.statusCode || 500,
    });
});
